import { Pipe, PipeTransform } from '@angular/core';
import {
  DurationDisplayFormat,
  formatDays
} from 'src/app/shared/models/attributes/durationFormula';

/**
 * Formats a raw integer day count (as produced by a `duration` calc field) into the user-facing
 * string the calc field's `displayFormat` configures. Backend stores the raw signed integer; the
 * UI applies the format hint at render time so the same materialized value reads consistently
 * across surfaces (people table, profile cards, exports). Thin wrapper around
 * {@link formatDays} so the formatting is reusable from component code too.
 */
@Pipe({
  name: 'daysFormatted',
  standalone: false
})
export class DaysFormattedPipe implements PipeTransform {
  transform(value: string | number | null | undefined, format: DurationDisplayFormat): string {
    return formatDays(value, format);
  }
}
